import { render, staticRenderFns } from "./wxfAddGoods.vue?vue&type=template&id=0441487e&scoped=true&"
import script from "./wxfAddGoods.vue?vue&type=script&lang=js&"
export * from "./wxfAddGoods.vue?vue&type=script&lang=js&"
import style0 from "./wxfAddGoods.vue?vue&type=style&index=0&id=0441487e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0441487e",
  null
  
)

export default component.exports